(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["checkbox"] && !Shopify.designMode) return;
  try {
    (function () {
    function applyIndeterminate(root) {
      var scope = root || document;
      var boxes = scope.querySelectorAll('input[type="checkbox"][data-indeterminate="true"]');
      for (var i = 0; i < boxes.length; i++) {
        boxes[i].indeterminate = true;
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        applyIndeterminate(document);
      });
    } else {
      applyIndeterminate(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["club-pricing-gate"] && !Shopify.designMode) return;
  try {
    class ClubPricingGate extends HTMLElement {
    connectedCallback() {
      if (localStorage.getItem('eureka:club-gate-dismissed') === '1') return;
      this.classList.remove('hidden');
      const dismiss = this.querySelector('[data-club-gate-dismiss]');
      if (dismiss) {
        dismiss.addEventListener('click', () => {
          localStorage.setItem('eureka:club-gate-dismissed', '1');
          this.classList.add('hidden');
        });
      }
    }
  }
  if (!customElements.get('club-pricing-gate')) {
    customElements.define('club-pricing-gate', ClubPricingGate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delivery-estimate-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__eurekaDeliveryEstimateInit) return;
    window.__eurekaDeliveryEstimateInit = true;

    const KEY = 'eureka:delivery-locality';
    const api = () => window.StoreAvailability;

    // Guards a slow response for an abandoned query from overwriting a newer one.
    let seq = 0;

    const money = (value) => {
      // Prices are decimal strings on the metaobject ("227.0"). Format with the theme's
      // money helper when available so currency presentation stays consistent.
      const n = Number(value);
      if (!Number.isFinite(n)) return '';
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(Math.round(n * 100), window.FoxTheme?.moneyFormat);
      }
      return n.toLocaleString(undefined, { style: 'currency', currency: 'AUD' });
    };

    // The locale string carries a double-brace `locality` placeholder. The needle is
    // built by concatenation so no literal Liquid tag appears in this JS block: Theme
    // Check flags one as a variable (StaticStylesheetAndJavascriptTags), and any step
    // that DID evaluate it would substitute an empty string and silently break every
    // locality line.
    const LOCALITY_TOKEN = '{' + '{ locality }' + '}';

    const esc = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
      }[c]));

    function els(drawer) {
      return {
        body: drawer.querySelector('.de-drawer__body'),
        input: drawer.querySelector('input[name="delivery_estimate_postcode"]'),
        status: drawer.querySelector('[data-de-status]'),
        suggestions: drawer.querySelector('[data-de-suggestions]'),
        result: drawer.querySelector('[data-de-result]'),
        locality: drawer.querySelector('[data-de-locality]'),
        price: drawer.querySelector('[data-de-price]'),
        note: drawer.querySelector('[data-de-note]'),
      };
    }

    function reset(drawer) {
      const el = els(drawer);
      if (el.status) el.status.textContent = '';
      if (el.result) el.result.hidden = true;
    }

    /**
     * Paint a resolved match, persist it, and update the availability block.
     *
     * Three distinct outcomes, deliberately NOT collapsed:
     *   price present            -> show the price
     *   price null               -> "Delivery quote required" (a real, priced-out area)
     *   priceUnavailable === true -> lookup FAILED; show a retry, never "quote required"
     */
    function applyMatch(drawer, match) {
      const el = els(drawer);
      if (!el.body) return;

      if (el.status) el.status.textContent = '';

      if (match.priceUnavailable) {
        if (el.status) el.status.textContent = el.body.dataset.unavailable || '';
        if (el.result) el.result.hidden = true;
        return;
      }

      const tpl = el.body.dataset.deliversTo || '';
      if (el.locality) el.locality.textContent = tpl.replace(LOCALITY_TOKEN, match.label || '');

      if (match.price != null) {
        if (el.price) el.price.textContent = money(match.price);
        if (el.note) el.note.textContent = '';
      } else {
        if (el.price) el.price.textContent = el.body.dataset.quote || '';
        if (el.note) el.note.textContent = el.body.dataset.quoteNote || '';
      }
      if (el.result) el.result.hidden = false;

      // Persist so the choice survives navigation, and mirror it onto the PDP
      // availability block so the shopper sees it without reopening the drawer.
      try {
        localStorage.setItem(KEY, JSON.stringify(match));
      } catch (e) {
        /* private mode - the drawer still works, it just will not remember */
      }
      paintBlock(match);
    }

    /**
     * Rewrite the PDP availability block's delivery column in place.
     *
     * The block's default heading names a generic or placeholder area, so appending the
     * resolved estimate below it put two contradicting answers on screen. The status and
     * price lines are REPLACED instead.
     *
     * Optional by design: the block may not be on the template, in which case the
     * drawer still functions standalone.
     */
    function paintBlock(match) {
      const status = document.querySelector('[data-availability-delivery-status]');
      const price = document.querySelector('[data-availability-delivery-price]');
      const body = document.querySelector('.de-drawer__body');
      if (!body || (!status && !price)) return;

      // A failed lookup must not overwrite good copy with a wrong answer.
      if (match.priceUnavailable) return;

      if (status) {
        status.textContent = (body.dataset.deliversTo || '').replace(
          LOCALITY_TOKEN,
          match.label || ''
        );
        status.hidden = false;
      }
      if (price) {
        price.textContent = match.price != null ? money(match.price) : body.dataset.quote || '';
        price.hidden = false;
      }
    }

    /**
     * Fetch and render type-ahead suggestions.
     *
     * One Google session token spans every keystroke of a search plus the final
     * resolution, so a shopper typing "Newtown" costs ONE billable session rather than
     * seven requests. Minted lazily and cleared on selection.
     */
    async function suggest(drawer, term) {
      const el = els(drawer);
      const value = (term || '').trim();
      if (!el.suggestions) return;

      const sa = api();
      if (!sa || !sa.geocodeConfigured || value.length < 2) {
        hideSuggestions(drawer);
        return;
      }

      if (!drawer.__deSession) drawer.__deSession = sa.newSession();

      const mine = ++seq;
      const out = await sa.suggest(value, drawer.__deSession);
      if (mine !== seq) return;

      if (!out.ok || !out.suggestions.length) {
        hideSuggestions(drawer);
        return;
      }

      el.suggestions.textContent = '';
      out.suggestions.forEach((sug, i) => {
        const li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        li.innerHTML = `
          <button type="button" class="de-drawer__suggestion" role="option"
                  aria-selected="false" data-de-suggestion="${i}">
            ${esc(sug.label)}
          </button>
        `;
        el.suggestions.appendChild(li);
      });
      drawer.__deSuggestions = out.suggestions;
      el.suggestions.hidden = false;
    }

    function hideSuggestions(drawer) {
      const el = els(drawer);
      if (!el.suggestions) return;
      el.suggestions.hidden = true;
      el.suggestions.textContent = '';
      drawer.__deSuggestions = null;
    }

    /**
     * Resolve a picked suggestion into a priced locality.
     *
     * Only a SELECTED suggestion can produce an estimate — that is what guarantees the
     * rate key belongs to a place the shopper actually chose.
     */
    async function choose(drawer, index) {
      const el = els(drawer);
      const sug = (drawer.__deSuggestions || [])[index];
      if (!sug || !el.body) return;

      hideSuggestions(drawer);
      if (el.input) el.input.value = sug.label;
      if (el.status) el.status.textContent = el.body.dataset.searching || '';

      const sa = api();
      const mine = ++seq;
      const out = await sa.place(sug.placeId, drawer.__deSession);
      if (mine !== seq) return;

      // The session ends at resolution; the next search mints a fresh token.
      drawer.__deSession = null;

      if (!out.ok || !out.match) {
        if (el.status) {
          el.status.textContent = out.ok
            ? el.body.dataset.noResults || ''
            : el.body.dataset.unavailable || '';
        }
        return;
      }

      drawer.__deResolvedFor = sug.label;
      applyMatch(drawer, out.match);
    }

    /**
     * Confirm handler.
     *
     * An estimate can ONLY come from a selected suggestion, so Confirm has three jobs
     * and never guesses:
     *   - estimate already showing for this input -> close (submit closes, per the brief)
     *   - exactly one suggestion open             -> take it, resolve, close
     *   - otherwise                               -> prompt to pick, keep the drawer open
     *
     * Closing while suggestions are open would discard the pending choice and leave the
     * availability block stale.
     */
    async function confirm(drawer) {
      const el = els(drawer);
      if (!el.input) return;

      const term = el.input.value.trim();
      const showing = el.result && !el.result.hidden;
      if (showing && drawer.__deResolvedFor === term) {
        close(drawer);
        return;
      }

      const open = drawer.__deSuggestions || [];
      if (open.length === 1) {
        await choose(drawer, 0);
        const after = els(drawer);
        if (after.result && !after.result.hidden) close(drawer);
        return;
      }

      // Nothing selected: ask rather than geocoding free text, which is exactly the
      // silent-wrong-suburb case this flow exists to prevent.
      if (el.status && el.body) {
        el.status.textContent = open.length
          ? el.body.dataset.chooseHelp || ''
          : el.body.dataset.noResults || '';
      }
      if (open.length) el.input.focus();
    }

    function close(drawer) {
      // basic-modal owns open/close; drive it through its own close control so focus
      // return and the overlay teardown behave exactly as they do elsewhere.
      const btn = drawer.querySelector('.drawer__close-btn');
      if (btn) btn.click();
      else drawer.hidden = true;
    }

    function toggleClear(input) {
      const clear = input.closest('.de-drawer__field')?.querySelector('[data-de-clear]');
      if (clear) clear.hidden = !input.value.trim();
    }

    document.addEventListener('DOMContentLoaded', () => {
      let saved = null;
      try {
        saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      } catch (e) {
        saved = null;
      }
      if (!saved) return;

      document.querySelectorAll('input[name="delivery_estimate_postcode"]').forEach((input) => {
        if (!input.value) input.value = saved.postcode || saved.suburb || '';
        toggleClear(input);
      });
      // Repaint the last estimate without a network call.
      document.querySelectorAll('.de-drawer').forEach((drawer) => {
        const el = els(drawer);
        if (!el.body) return;
        const tpl = el.body.dataset.deliversTo || '';
        if (el.locality) el.locality.textContent = tpl.replace(LOCALITY_TOKEN, saved.label || '');
        if (el.price) {
          el.price.textContent = saved.price != null ? money(saved.price) : el.body.dataset.quote || '';
        }
        if (el.note) el.note.textContent = saved.price != null ? '' : el.body.dataset.quoteNote || '';
        if (el.result) el.result.hidden = false;
      });
      paintBlock(saved);
    });

    document.addEventListener('click', (event) => {
      const drawer = event.target.closest('.de-drawer');
      if (!drawer) return;

      if (event.target.closest('[data-de-confirm]')) {
        confirm(drawer);
        return;
      }

      const suggestion = event.target.closest('[data-de-suggestion]');
      if (suggestion) {
        // Selecting resolves and closes: the shopper has disambiguated, so the estimate
        // is final ("submitting the modal closes it and updates the block").
        choose(drawer, Number(suggestion.dataset.deSuggestion)).then(() => {
          const after = els(drawer);
          if (after.result && !after.result.hidden) close(drawer);
        });
        return;
      }

      if (event.target.closest('[data-de-clear]')) {
        const el = els(drawer);
        if (el.input) {
          el.input.value = '';
          toggleClear(el.input);
          el.input.focus();
        }
        hideSuggestions(drawer);
        drawer.__deSession = null;
        drawer.__deResolvedFor = null;
        reset(drawer);
        return;
      }

      // A click anywhere else in the drawer dismisses an open suggestion list.
      if (!event.target.closest('.de-drawer__field')) hideSuggestions(drawer);
    });

    // Debounced type-ahead. 250ms balances responsiveness against billed calls; the
    // session token means a whole search is charged once regardless of keystrokes.
    let debounce;
    document.addEventListener('input', (event) => {
      const input = event.target.closest('input[name="delivery_estimate_postcode"]');
      if (!input) return;
      const drawer = input.closest('.de-drawer');
      if (!drawer) return;
      toggleClear(input);
      // Typing invalidates any resolved estimate - it no longer matches the input.
      drawer.__deResolvedFor = null;
      clearTimeout(debounce);
      debounce = setTimeout(() => suggest(drawer, input.value), 250);
    });

    document.addEventListener('keydown', (event) => {
      const input = event.target.closest('input[name="delivery_estimate_postcode"]');
      if (!input) return;
      const drawer = input.closest('.de-drawer');
      if (!drawer) return;

      const options = [...drawer.querySelectorAll('[data-de-suggestion]')];

      // Arrow keys move through the list; Enter takes the highlighted option. Without
      // this the listbox is mouse-only, which fails keyboard and screen-reader use.
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault();
        const current = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        const next =
          event.key === 'ArrowDown'
            ? Math.min(current + 1, options.length - 1)
            : Math.max(current - 1, 0);
        options.forEach((o, i) => o.setAttribute('aria-selected', String(i === next)));
        options[next].focus();
        return;
      }

      if (event.key === 'Escape') {
        hideSuggestions(drawer);
        return;
      }

      if (event.key === 'Enter') {
        event.preventDefault();
        const highlighted = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        if (highlighted >= 0) {
          choose(drawer, highlighted).then(() => {
            const after = els(drawer);
            if (after.result && !after.result.hidden) close(drawer);
          });
          return;
        }
        confirm(drawer);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facet-sort-menu"] && !Shopify.designMode) return;
  try {
    class SortMenu extends HTMLElement {
    connectedCallback() {
      this.native = this.querySelector('[data-sort-native]');
      this.trigger = this.querySelector('[data-sort-trigger]');
      this.popoverEl = this.querySelector('[data-sort-popover]');
      this.list = this.querySelector('[data-sort-list]');
      if (!this.native || !this.trigger || !this.popoverEl || !this.list) return;

      this.currentLabel = this.querySelector('[data-sort-current]');
      this.items = Array.from(this.querySelectorAll('.sort-menu__item'));
      this.activeIndex = -1;

      this.classList.add('is-enhanced');
      this.trigger.hidden = false;
      this.popoverEl.hidden = true;
      this.setAttribute('data-state', 'closed');

      this.onDocClick = this.onDocClick.bind(this);
      this.trigger.addEventListener('click', () => this.toggle());
      this.trigger.addEventListener('keydown', (e) => this.onTriggerKey(e));
      this.list.addEventListener('keydown', (e) => this.onListKey(e));
      this.items.forEach((item, i) => {
        item.addEventListener('click', () => this.select(i));
        item.addEventListener('mousemove', () => this.setActive(i));
      });
    }

    get isOpen() {
      return this.getAttribute('data-state') === 'open';
    }

    open() {
      this.setAttribute('data-state', 'open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.popoverEl.hidden = false;
      document.addEventListener('click', this.onDocClick);
      const current = this.items.findIndex((i) => i.classList.contains('is-selected'));
      this.setActive(current > -1 ? current : 0);
      window.requestAnimationFrame(() => this.list.focus());
    }

    close(returnFocus) {
      this.setAttribute('data-state', 'closed');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.popoverEl.hidden = true;
      document.removeEventListener('click', this.onDocClick);
      if (returnFocus) this.trigger.focus();
    }

    toggle() {
      if (this.isOpen) {
        this.close(true);
      } else {
        this.open();
      }
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.close(false);
    }

    setActive(index) {
      this.items.forEach((i) => i.classList.remove('is-active'));
      this.activeIndex = index;
      const item = this.items[index];
      if (item) {
        item.classList.add('is-active');
        this.list.setAttribute('aria-activedescendant', item.id);
        item.scrollIntoView({ block: 'nearest' });
      }
    }

    move(step) {
      if (!this.items.length) return;
      let next = this.activeIndex + step;
      if (next < 0) next = this.items.length - 1;
      if (next > this.items.length - 1) next = 0;
      this.setActive(next);
    }

    select(index) {
      const item = this.items[index];
      if (!item) return;
      const value = item.getAttribute('data-value');
      this.items.forEach((i) => {
        i.classList.remove('is-selected');
        i.setAttribute('aria-selected', 'false');
      });
      item.classList.add('is-selected');
      item.setAttribute('aria-selected', 'true');
      if (this.currentLabel) {
        const label = item.querySelector('.sort-menu__item-label');
        this.currentLabel.textContent = label ? label.textContent : '';
      }
      if (this.native.value !== value) {
        this.native.value = value;
        this.native.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.close(true);
    }

    onTriggerKey(e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.open();
      }
    }

    onListKey(e) {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          this.move(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          this.move(-1);
          break;
        case 'Home':
          e.preventDefault();
          this.setActive(0);
          break;
        case 'End':
          e.preventDefault();
          this.setActive(this.items.length - 1);
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (this.activeIndex > -1) this.select(this.activeIndex);
          break;
        case 'Escape':
          e.preventDefault();
          this.close(true);
          break;
        case 'Tab':
          this.close(false);
          break;
        default:
          break;
      }
    }
  }

  if (!customElements.get('sort-menu')) {
    customElements.define('sort-menu', SortMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["financing-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__eurekaFinancingTabsInit) return;
    window.__eurekaFinancingTabsInit = true;

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-financing-tab]');
      if (!tab) return;
      const drawer = tab.closest('.financing-drawer');
      if (!drawer) return;
      const index = tab.getAttribute('data-financing-tab');
      drawer.querySelectorAll('[data-financing-tab]').forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      drawer.querySelectorAll('[data-financing-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-financing-panel') !== index;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["find-in-store-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__eurekaFindInStoreInit) return;
    window.__eurekaFindInStoreInit = true;

    const KEY = 'eureka:fis-postcode';
    // The resolved coordinates for KEY. Persisted so a returning shopper's distances
    // survive a reload without re-billing a geocode round-trip.
    const ORIGIN_KEY = 'eureka:fis-origin';
    const STORE_KEY = 'eureka:my-store';
    // The store NAME is persisted alongside the id so the availability block can be
    // repainted on load without waiting for (or paying for) a Storefront round-trip.
    const STORE_NAME_KEY = 'eureka:my-store-name';
    const SHOW = 5;

    // The locale string carries a double-brace `store` placeholder. Built by
    // concatenation so no literal Liquid tag appears in this JS block — Theme Check
    // flags one as a variable (StaticStylesheetAndJavascriptTags), and any step that
    // evaluated it would substitute an empty string.
    const STORE_TOKEN = '{' + '{ store }' + '}';
    const TERM_TOKEN = '{' + '{ term }' + '}';
    const DISTANCE_TOKEN = '{' + '{ distance }' + '}';

    const myStore = () => localStorage.getItem(STORE_KEY);
    const api = () => window.StoreAvailability;

    // Origin for the proximity sort. Set by the locate button (real position) or by a
    // PICKED suggestion. null = let Shopify return its default order.
    let origin = null;
    // The label the current origin came from, so the heading names the place actually
    // sorted by rather than whatever is currently typed in the field.
    let originTerm = null;
    // Guard slow responses for abandoned queries overwriting newer ones. Separate
    // counters: suggestions and availability are independent request streams, and
    // sharing one would let a suggestion fetch cancel a store lookup.
    let requestSeq = 0;
    let suggestSeq = 0;

    function paintMine(drawer) {
      const mine = myStore();
      drawer.querySelectorAll('[data-store]').forEach((el) => {
        const isMine = !!mine && el.dataset.handle === mine;
        el.classList.toggle('fis-drawer__store--mine', isMine);
        const flag = el.querySelector('[data-store-flag]');
        if (flag) flag.hidden = !isMine;
        const set = el.querySelector('[data-store-set]');
        if (set) set.disabled = isMine;
      });
    }

    /**
     * Rewrite the PDP availability block's pickup status line in place.
     *
     * The block default names a generic or placeholder store, so once the shopper picks
     * theirs it is REPLACED rather than left to contradict the choice. Mirrors what the
     * delivery drawer does to its own column.
     *
     * Optional by design: the block may not be on the template.
     */
    function paintPickupBlock(storeName) {
      const target = document.querySelector('[data-availability-pickup-status]');
      const body = document.querySelector('.fis-drawer__body');
      if (!target || !body || !storeName) return;
      target.textContent = (body.dataset.pickupAt || '').replace(STORE_TOKEN, storeName);
      target.hidden = false;
    }

    const esc = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
      }[c]));

    /**
     * Display form for a phone number. The API returns E.164 ("+61283551910"), which
     * reads as an undifferentiated digit run; the design shows "02 8355 1910".
     *
     * Only AU numbers are reshaped — anything else is returned untouched rather than
     * mangled into a format it does not use. The tel: href keeps the raw E.164, which
     * is the most reliable thing to hand a dialler.
     */
    function phoneLabel(raw) {
      const s = String(raw || '').replace(/\s+/g, '');
      // +61 4XX XXX XXX -> 04XX XXX XXX (mobile)
      const mob = s.match(/^\+?61(4\d{2})(\d{3})(\d{3})$/);
      if (mob) return `0${mob[1]} ${mob[2]} ${mob[3]}`;
      // +61 X XXXX XXXX -> 0X XXXX XXXX (landline)
      const land = s.match(/^\+?61([2378])(\d{4})(\d{4})$/);
      if (land) return `0${land[1]} ${land[2]} ${land[3]}`;
      return raw;
    }

    /**
     * Great-circle distance in km between two {latitude, longitude} pairs.
     *
     * The design's top-right slot shows "0.8km", and `storeAvailability` returns each
     * location's coordinates, so this is computed rather than approximated. Only
     * meaningful once an ORIGIN exists (a picked locality or the device position) —
     * without one there is nothing to measure from and the slot falls back to pickUpTime.
     */
    function distanceKm(origin, addr) {
      // `Number(null)` is 0 and `Number('')` is 0, both of which are finite - so a
      // location with no coordinates would measure against (0, 0) in the Gulf of Guinea
      // and report a confident 15,000km. Reject the empty cases BEFORE coercing.
      const raw = (v) => (v === null || v === undefined || v === '' ? NaN : Number(v));
      const lat2 = raw(addr && addr.latitude);
      const lon2 = raw(addr && addr.longitude);
      if (!origin || !Number.isFinite(lat2) || !Number.isFinite(lon2)) return null;
      const R = 6371;
      const rad = (deg) => (deg * Math.PI) / 180;
      const dLat = rad(lat2 - origin.latitude);
      const dLon = rad(lon2 - origin.longitude);
      const h =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(rad(origin.latitude)) * Math.cos(rad(lat2)) * Math.sin(dLon / 2) ** 2;
      return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
    }

    /** Design shows one decimal under 10km ("0.8km"), whole km above ("11km"). */
    function distanceLabel(km, template) {
      if (km == null) return null;
      const value = km < 10 ? km.toFixed(1) : String(Math.round(km));
      return (template || '').replace(DISTANCE_TOKEN, value);
    }

    /** One store row. Mirrors the markup the Liquid loop used to emit. */
    function row(node, d) {
      const loc = node.location || {};
      const a = loc.address || {};
      const street = [a.address1, a.address2].filter(Boolean).join(', ');
      const locality = [a.city, a.provinceCode || a.province, a.zip].filter(Boolean).join(' ');
      const mapsQuery = encodeURIComponent([loc.name, street, locality].filter(Boolean).join(' '));
      // Design's top-right slot is a DISTANCE ("0.8km"). It only exists once the shopper
      // has given us an origin to measure from; before that the pickup lead time is the
      // most useful thing that slot can honestly carry.
      const meta = distanceLabel(distanceKm(origin, a), d.distance) || node.pickUpTime || a.city || '';

      const li = document.createElement('li');
      li.className = 'fis-drawer__store';
      li.setAttribute('data-store', '');
      li.dataset.handle = loc.id || '';
      li.innerHTML = `
        <div class="fis-drawer__store-head">
          <p class="fis-drawer__store-name">${esc(loc.name)}</p>
          <span class="fis-drawer__store-meta" data-store-meta>${esc(meta)}</span>
          <span class="fis-drawer__store-flag" data-store-flag hidden>${esc(d.yourStore)}</span>
        </div>
        ${street ? `<p class="fis-drawer__store-address">${esc(street)}</p>` : ''}
        ${
          /* Design (12240:134134-134139) draws BOTH rows on every store: they are two
             independent facts, not two states of one fact. "On display" is about the
             showroom floor; "Pickup available" is about click & collect readiness. An
             either/or read them as mutually exclusive, which they are not. */ ''
        }
        <ul class="fis-drawer__status">
          <li class="fis-drawer__status-row">
            <span class="fis-drawer__dot fis-drawer__dot--display"></span>
            <span>${esc(d.onDisplay)}</span>
          </li>
          <li class="fis-drawer__status-row">
            <span class="fis-drawer__dot fis-drawer__dot--pickup"></span>
            <span>${esc(d.pickupLabel)}${
              d.pickupNote ? `<span class="fis-drawer__status-note">${esc(d.pickupNote)}</span>` : ''
            }</span>
          </li>
        </ul>
        <div class="fis-drawer__actions">
          <a class="fis-drawer__link" href="https://www.google.com/maps/search/?api=1&query=${mapsQuery}" target="_blank" rel="noopener">${esc(d.directions)}</a>
          ${a.phone ? `<a class="fis-drawer__link" href="tel:${esc(String(a.phone).replace(/\s/g, ''))}">${esc(phoneLabel(a.phone))}</a>` : ''}
          <button type="button" class="fis-drawer__link fis-drawer__link--set" data-store-set>${esc(d.setStore)}</button>
        </div>
      `;
      return li;
    }

    /**
     * Re-query pickup availability and repaint.
     *
     * Shopify does the proximity sort via `near`, so there is no client-side ranking
     * here. An empty result is rendered as the design's empty state — it means no
     * location has local pickup enabled for this variant, which is a normal state and
     * must not read as an error.
     */
    async function hydrate(drawer, term) {
      const body = drawer.querySelector('.fis-drawer__body');
      const results = drawer.querySelector('[data-store-results]');
      const list = drawer.querySelector('[data-store-list]');
      const heading = results && results.querySelector('[data-store-heading]');
      if (!body || !results || !list) return;

      const handle = body.dataset.productHandle;
      const sa = api();
      if (!handle || !sa || !sa.configured) {
        // No token configured: stay silent rather than showing a broken list.
        results.hidden = true;
        return;
      }

      const seq = ++requestSeq;
      const out = await sa.availability(handle, origin, SHOW);
      if (seq !== requestSeq) return; // a newer query superseded this one

      if (!out.ok) {
        // Transport/scope failure. Keep the shopper-facing UI quiet, but surface the
        // scope case on the console so a misconfiguration is diagnosable.
        if (out.reason === 'denied') {
          console.warn(
            '[find-in-store] Storefront token is missing the ' +
              'unauthenticated_read_product_pickup_locations scope.'
          );
        }
        results.hidden = true;
        return;
      }

      const d = {
        yourStore: body.dataset.yourStore || '',
        onDisplay: body.dataset.onDisplay || '',
        pickupLabel: body.dataset.pickupLabel || '',
        pickupNote: body.dataset.pickupNote || '',
        directions: body.dataset.directions || '',
        setStore: body.dataset.setStore || '',
        distance: body.dataset.distance || '',
      };

      list.textContent = '';
      out.stores.forEach((node) => list.appendChild(row(node, d)));

      // A saved store always leads the list - the store-set state in the brief.
      const mine = myStore();
      if (mine) {
        const saved = list.querySelector(`[data-handle="${CSS.escape(mine)}"]`);
        if (saved) list.insertBefore(saved, list.firstChild);
      }

      if (heading) {
        // The proximity heading ("Showrooms near X" / "All showrooms") is deliberately
        // NOT rendered - the design shows the list starting directly under the search
        // field, and each row now carries its own distance, which states the proximity
        // per store rather than once for the whole list.
        //
        // The element itself stays: it is the aria-live region that announces the
        // no-results case and the geolocation errors, which have no other channel.
        // theme.css hides p:empty, so it costs nothing when it has no message.
        const typed = (term || '').trim();
        heading.textContent = out.stores.length
          ? ''
          : (body.dataset.emptyTemplate || '').replace(TERM_TOKEN, typed);
      }

      results.hidden = false;
      paintMine(drawer);
    }

    /**
     * Fetch and render type-ahead locality suggestions.
     *
     * One Google session token spans every keystroke plus the final resolution, so a
     * shopper typing "Newtown" costs ONE billable session rather than seven requests.
     * Minted lazily, cleared on selection.
     */
    async function suggest(drawer, term) {
      const list = drawer.querySelector('[data-store-suggestions]');
      const value = (term || '').trim();
      if (!list) return;

      const sa = api();
      if (!sa || !sa.geocodeConfigured || value.length < 2) {
        hideSuggestions(drawer);
        return;
      }

      if (!drawer.__fisSession) drawer.__fisSession = sa.newSession();

      const mine = ++suggestSeq;
      const out = await sa.suggest(value, drawer.__fisSession);
      if (mine !== suggestSeq) return;

      if (!out.ok || !out.suggestions.length) {
        hideSuggestions(drawer);
        return;
      }

      list.textContent = '';
      out.suggestions.forEach((sug, i) => {
        const li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        li.innerHTML = `
          <button type="button" class="fis-drawer__suggestion" role="option"
                  aria-selected="false" data-store-suggestion="${i}">
            ${esc(sug.label)}
          </button>
        `;
        list.appendChild(li);
      });
      drawer.__fisSuggestions = out.suggestions;
      list.hidden = false;
    }

    function hideSuggestions(drawer) {
      const list = drawer.querySelector('[data-store-suggestions]');
      if (!list) return;
      list.hidden = true;
      list.textContent = '';
      drawer.__fisSuggestions = null;
    }

    /**
     * Resolve a picked suggestion into an exact origin, then hydrate.
     *
     * Only a SELECTED suggestion sets a proximity origin — that is what guarantees the
     * "near X" heading refers to the place the shopper actually chose.
     */
    async function choose(drawer, index) {
      const sug = (drawer.__fisSuggestions || [])[index];
      const input = drawer.querySelector('input[name="find_in_store_postcode"]');
      if (!sug) return;

      hideSuggestions(drawer);
      if (input) {
        input.value = sug.label;
        toggleClear(input);
      }

      const sa = api();
      const mine = ++requestSeq;
      const out = await sa.place(sug.placeId, drawer.__fisSession);

      // The session ends at resolution; the next search mints a fresh token.
      drawer.__fisSession = null;
      if (mine !== requestSeq) return;

      if (out.ok && out.match) {
        origin = { latitude: out.match.latitude, longitude: out.match.longitude };
        originTerm = sug.label;
        try {
          localStorage.setItem(KEY, sug.label);
          localStorage.setItem(ORIGIN_KEY, JSON.stringify(origin));
        } catch (e) {
          /* private mode - the drawer still works, it just will not remember */
        }
      } else {
        // Resolution failed: fall back to the unsorted list rather than ranking by a
        // stale origin, which would silently point at the previous search.
        origin = null;
        originTerm = null;
      }
      hydrate(drawer, input ? input.value : sug.label);
    }

    /**
     * Search handler.
     *
     * Unlike the delivery drawer this never refuses to act — FIS ranks, it does not
     * price, so an unsorted list is an acceptable outcome where a wrong price is not:
     *   - exactly one suggestion open -> take it and sort by it
     *   - several open                -> prompt to pick, keep them visible
     *   - none                        -> hydrate unsorted under "All showrooms"
     */
    async function apply(drawer) {
      const input = drawer && drawer.querySelector('input[name="find_in_store_postcode"]');
      if (!input) return;
      const value = input.value.trim();
      const open = drawer.__fisSuggestions || [];

      if (open.length === 1) {
        await choose(drawer, 0);
        return;
      }

      if (open.length > 1) {
        const body = drawer.querySelector('.fis-drawer__body');
        const results = drawer.querySelector('[data-store-results]');
        const heading = results && results.querySelector('[data-store-heading]');
        if (results) results.hidden = false;
        if (heading && body) heading.textContent = body.dataset.chooseHelp || '';
        input.focus();
        return;
      }

      // Nothing to pick: show every showroom rather than geocoding free text, which is
      // exactly the silently-wrong-suburb case the suggestion flow exists to prevent.
      origin = null;
      originTerm = null;
      hydrate(drawer, value);
    }

    function toggleClear(input) {
      const clear = input.closest('.fis-drawer__field')?.querySelector('[data-store-clear]');
      if (clear) clear.hidden = !input.value.trim();
    }

    document.addEventListener('DOMContentLoaded', () => {
      const saved = localStorage.getItem(KEY);
      document.querySelectorAll('input[name="find_in_store_postcode"]').forEach((input) => {
        if (saved && !input.value) input.value = saved;
        toggleClear(input);
      });
      // Restore the proximity origin that goes with the remembered postcode, so the
      // distance column is populated on first open rather than only after a re-search.
      try {
        const stored = JSON.parse(localStorage.getItem(ORIGIN_KEY) || 'null');
        if (stored && Number.isFinite(stored.latitude) && Number.isFinite(stored.longitude)) {
          origin = stored;
          originTerm = saved || null;
        }
      } catch (e) {
        /* corrupt or unreadable - fall through to the unsorted list */
      }
      document.querySelectorAll('.fis-drawer').forEach(paintMine);
      // Restore the chosen store into the availability block without a network call.
      let savedName = null;
      try {
        savedName = localStorage.getItem(STORE_NAME_KEY);
      } catch (e) {
        savedName = null;
      }
      if (savedName) paintPickupBlock(savedName);
    });

    document.addEventListener('click', (event) => {
      const drawer = event.target.closest('.fis-drawer');
      if (!drawer) return;

      if (event.target.closest('[data-find-in-store-confirm]')) {
        apply(drawer);
        return;
      }

      const suggestion = event.target.closest('[data-store-suggestion]');
      if (suggestion) {
        choose(drawer, Number(suggestion.dataset.storeSuggestion));
        return;
      }

      const clear = event.target.closest('[data-store-clear]');
      if (clear) {
        origin = null;
        originTerm = null;
        drawer.__fisSession = null;
        try {
          // Drop the persisted origin too - keeping it would resurrect distances for a
          // postcode the shopper just cleared.
          localStorage.removeItem(ORIGIN_KEY);
          localStorage.removeItem(KEY);
        } catch (e) {
          /* private mode - nothing to clean up */
        }
        hideSuggestions(drawer);
        const input = drawer.querySelector('input[name="find_in_store_postcode"]');
        if (input) {
          input.value = '';
          toggleClear(input);
          input.focus();
        }
        hydrate(drawer, '');
        return;
      }

      const locate = event.target.closest('[data-store-locate]');
      if (locate) {
        const body = drawer.querySelector('.fis-drawer__body');
        const results = drawer.querySelector('[data-store-results]');
        const heading = results && results.querySelector('[data-store-heading]');
        const say = (msg) => {
          if (results) results.hidden = false;
          if (heading) heading.textContent = msg || '';
        };
        if (!navigator.geolocation) {
          say(body && body.dataset.unavailable);
          return;
        }
        locate.setAttribute('aria-busy', 'true');
        say(body && body.dataset.locating);
        // A pending suggestion list would be stale the moment real coordinates land.
        hideSuggestions(drawer);
        drawer.__fisSession = null;
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            locate.removeAttribute('aria-busy');
            // The shopper's real position beats any picked locality.
            origin = { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
            originTerm = null;
            try {
              localStorage.setItem(ORIGIN_KEY, JSON.stringify(origin));
              // The field is cleared below, so the remembered postcode no longer
              // describes this origin.
              localStorage.removeItem(KEY);
            } catch (e) {
              /* private mode - the position just will not persist */
            }
            const input = drawer.querySelector('input[name="find_in_store_postcode"]');
            if (input) {
              input.value = '';
              toggleClear(input);
            }
            hydrate(drawer, '');
          },
          (err) => {
            locate.removeAttribute('aria-busy');
            origin = null;
            originTerm = null;
            say(body && (err && err.code === 1 ? body.dataset.denied : body.dataset.unavailable));
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
        return;
      }

      const set = event.target.closest('[data-store-set]');
      if (set) {
        const store = set.closest('[data-store]');
        if (store) {
          const name = store.querySelector('.fis-drawer__store-name')?.textContent.trim() || '';
          try {
            localStorage.setItem(STORE_KEY, store.dataset.handle);
            localStorage.setItem(STORE_NAME_KEY, name);
          } catch (e) {
            /* private mode - the choice just will not persist */
          }
          paintMine(drawer);
          paintPickupBlock(name);
        }
        return;
      }

      // A click anywhere else in the drawer dismisses an open suggestion list.
      if (!event.target.closest('.fis-drawer__field')) hideSuggestions(drawer);
    });

    // Debounced type-ahead. 250ms matches the delivery drawer; the session token means
    // a whole search is billed once regardless of keystroke count.
    let debounce;
    document.addEventListener('input', (event) => {
      const input = event.target.closest('input[name="find_in_store_postcode"]');
      if (!input) return;
      const drawer = input.closest('.fis-drawer');
      if (!drawer) return;
      toggleClear(input);
      // Typing invalidates the picked origin - it no longer matches the field, and
      // keeping it would sort the list by the shopper's PREVIOUS suburb.
      if (originTerm && input.value.trim() !== originTerm) {
        origin = null;
        originTerm = null;
      }
      clearTimeout(debounce);
      debounce = setTimeout(() => suggest(drawer, input.value), 250);
    });

    document.addEventListener('keydown', (event) => {
      // Scope to the FIELD, not the input: arrowing into the list moves focus onto a
      // suggestion button, and keying off the input alone would strand the shopper
      // there with dead arrow keys.
      const field = event.target.closest('.fis-drawer__field');
      if (!field) return;
      const drawer = field.closest('.fis-drawer');
      if (!drawer) return;

      const options = [...drawer.querySelectorAll('[data-store-suggestion]')];

      // Arrow keys move through the list; Enter takes the highlighted option. Without
      // this the listbox is mouse-only, which fails keyboard and screen-reader use.
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault();
        const current = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        const next =
          event.key === 'ArrowDown'
            ? Math.min(current + 1, options.length - 1)
            : Math.max(current - 1, 0);
        options.forEach((o, i) => o.setAttribute('aria-selected', String(i === next)));
        options[next].focus();
        return;
      }

      if (event.key === 'Escape') {
        hideSuggestions(drawer);
        const input = drawer.querySelector('input[name="find_in_store_postcode"]');
        if (input) input.focus();
        return;
      }

      if (event.key === 'Enter') {
        // On a suggestion button, let the native click fire - the click handler already
        // resolves it, and intercepting here would double-resolve.
        if (event.target.closest('[data-store-suggestion]')) return;
        event.preventDefault();
        const highlighted = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        if (highlighted >= 0) {
          choose(drawer, highlighted);
          return;
        }
        apply(drawer);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-dropdown"] && !Shopify.designMode) return;
  try {
    class DropdownField extends HTMLElement {
    connectedCallback() {
      this.native = this.querySelector('[data-dropdown-native]');
      this.trigger = this.querySelector('[data-dropdown-trigger]');
      this.popover = this.querySelector('[data-dropdown-popover]');
      this.list = this.querySelector('[data-dropdown-list]');
      this.valueEl = this.querySelector('[data-dropdown-value]');
      this.emptyEl = this.querySelector('[data-dropdown-empty]');
      this.search = this.querySelector('.dropdown__search input');
      if (!this.trigger || !this.native || !this.list) return;

      this.multiple = this.hasAttribute('data-multiple');
      this.items = Array.from(this.querySelectorAll('.dropdown__item'));
      this.placeholder = this.valueEl ? this.valueEl.textContent.trim() : '';
      this.activeIndex = -1;
      this.typeahead = '';
      this.typeaheadTimer = null;

      this.classList.add('is-enhanced');
      this.trigger.hidden = false;
      this.popover.hidden = true;

      this.onDocClick = this.onDocClick.bind(this);
      this.trigger.addEventListener('click', () => this.toggle());
      this.trigger.addEventListener('keydown', (e) => this.onTriggerKey(e));
      this.list.addEventListener('keydown', (e) => this.onListKey(e));
      this.items.forEach((item, i) => {
        item.addEventListener('click', () => this.select(i));
        item.addEventListener('mousemove', () => this.setActive(i));
      });
      if (this.search) {
        this.search.addEventListener('input', () => this.filter(this.search.value));
        this.search.addEventListener('keydown', (e) => this.onSearchKey(e));
      }
    }

    get isOpen() {
      return this.getAttribute('data-state') === 'open';
    }

    open() {
      if (this.trigger.disabled) return;
      this.setAttribute('data-state', 'open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.popover.hidden = false;
      document.addEventListener('click', this.onDocClick);
      const focusTarget = this.search || this.list;
      const current = this.items.findIndex((i) => i.classList.contains('is-selected'));
      this.setActive(current > -1 ? current : this.firstVisible());
      window.requestAnimationFrame(() => focusTarget.focus());
    }

    close(returnFocus) {
      this.setAttribute('data-state', 'closed');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.popover.hidden = true;
      document.removeEventListener('click', this.onDocClick);
      if (returnFocus) this.trigger.focus();
    }

    toggle() {
      this.isOpen ? this.close(true) : this.open();
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.close(false);
    }

    firstVisible() {
      return this.items.findIndex((i) => !i.hidden);
    }

    setActive(index) {
      this.items.forEach((i) => i.classList.remove('is-active'));
      this.activeIndex = index;
      const item = this.items[index];
      if (item) {
        item.classList.add('is-active');
        this.list.setAttribute('aria-activedescendant', item.id);
        item.scrollIntoView({ block: 'nearest' });
      }
    }

    move(step) {
      const visible = this.items.map((i, idx) => (i.hidden ? -1 : idx)).filter((i) => i > -1);
      if (!visible.length) return;
      const pos = visible.indexOf(this.activeIndex);
      let next;
      if (step > 0) next = pos < 0 || pos === visible.length - 1 ? visible[0] : visible[pos + 1];
      else next = pos <= 0 ? visible[visible.length - 1] : visible[pos - 1];
      this.setActive(next);
    }

    select(index) {
      const item = this.items[index];
      if (!item) return;
      const value = item.getAttribute('data-value');
      if (this.multiple) {
        item.classList.toggle('is-selected');
        const on = item.classList.contains('is-selected');
        item.setAttribute('aria-selected', on ? 'true' : 'false');
        const opt = this.native.querySelector('option[value="' + this.escapeAttr(value) + '"]');
        if (opt) opt.selected = on;
      } else {
        this.items.forEach((i) => {
          i.classList.remove('is-selected');
          i.setAttribute('aria-selected', 'false');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-selected', 'true');
        this.native.value = value;
      }
      this.syncValueLabel();
      this.native.dispatchEvent(new Event('change', { bubbles: true }));
      if (!this.multiple) this.close(true);
    }

    syncValueLabel() {
      const chosen = this.items.filter((i) => i.classList.contains('is-selected'));
      if (this.valueEl) {
        this.valueEl.textContent = chosen.length
          ? chosen.map((i) => i.getAttribute('data-label')).join(', ')
          : this.placeholder;
      }
    }

    filter(term) {
      const q = term.trim().toLowerCase();
      let visible = 0;
      this.items.forEach((item) => {
        const match = item.getAttribute('data-label').toLowerCase().indexOf(q) > -1;
        item.hidden = q !== '' && !match;
        if (!item.hidden) visible += 1;
      });
      if (this.emptyEl) {
        if (visible === 0) {
          this.emptyEl.hidden = false;
          this.emptyEl.textContent = this.emptyEl.getAttribute('data-empty-template')
            ? this.emptyEl.getAttribute('data-empty-template').replace('__term__', term)
            : '';
        } else {
          this.emptyEl.hidden = true;
        }
      }
      this.setActive(this.firstVisible());
    }

    onTriggerKey(e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.open();
      }
    }

    onListKey(e) {
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); this.move(1); break;
        case 'ArrowUp': e.preventDefault(); this.move(-1); break;
        case 'Home': e.preventDefault(); this.setActive(this.firstVisible()); break;
        case 'End': e.preventDefault(); this.setActive(this.lastVisible()); break;
        case 'Enter':
        case ' ': e.preventDefault(); if (this.activeIndex > -1) this.select(this.activeIndex); break;
        case 'Escape': e.preventDefault(); this.close(true); break;
        case 'Tab': this.close(false); break;
        default: this.onTypeahead(e.key);
      }
    }

    onSearchKey(e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); this.list.focus(); this.move(1); }
      else if (e.key === 'Escape') { e.preventDefault(); this.close(true); }
      else if (e.key === 'Enter') { e.preventDefault(); if (this.activeIndex > -1) this.select(this.activeIndex); }
    }

    lastVisible() {
      for (let i = this.items.length - 1; i >= 0; i -= 1) if (!this.items[i].hidden) return i;
      return -1;
    }

    onTypeahead(key) {
      if (key.length !== 1) return;
      window.clearTimeout(this.typeaheadTimer);
      this.typeahead += key.toLowerCase();
      this.typeaheadTimer = window.setTimeout(() => { this.typeahead = ''; }, 500);
      const match = this.items.findIndex(
        (i) => !i.hidden && i.getAttribute('data-label').toLowerCase().indexOf(this.typeahead) === 0
      );
      if (match > -1) this.setActive(match);
    }

    escapeAttr(value) {
      return String(value).replace(/"/g, '\\"');
    }
  }

  if (!customElements.get('dropdown-field')) {
    customElements.define('dropdown-field', DropdownField);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', function (event) {
    var native = event.target;
    if (!native.classList || !native.classList.contains('input__native')) {
      return;
    }
    var wrapper = native.closest('.input');
    if (!wrapper) {
      return;
    }
    var counter = wrapper.querySelector('[data-input-count]');
    if (!counter) {
      return;
    }
    var template = counter.getAttribute('data-template') || '';
    counter.textContent = template.replace('__count__', native.value.length);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-drawer"] && !Shopify.designMode) return;
  try {
    // Search / cart links inside the drawer: close the menu drawer so the
  // target drawer isn't stacked on top of it.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-close-menu-drawer]');
    if (!trigger) return;
    const drawer = trigger.closest('menu-drawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pcard-color-swatch"] && !Shopify.designMode) return;
  try {
    /* Colour chips swap the card in place instead of navigating: the shopper
     stays on the grid and the card becomes the sibling product -- image, links,
     title and price. The chip remains an <a href>, so this is an enhancement
     layered over working navigation, and any failure below falls through to it.

     Delegated once per document rather than bound per card: a PLP renders up to
     ~60 chips, and facet/pagination re-renders replace card markup wholesale,
     which would strand per-node listeners. */
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('.swatches--product-card a');
    if (!chip) return;

    const item = chip.closest('[data-sibling]');
    const card = chip.closest('.product-card');
    if (!item || !card) return;

    const url = item.dataset.siblingUrl;
    if (!url) return;

    event.preventDefault();

    const image = card.querySelector('.product-card__image--main img, .product-card__image img');
    if (image && item.dataset.siblingImage) {
      image.srcset = '';
      image.src = item.dataset.siblingImage;
    }

    // Every link in the card points at the product, including the title, the
    // media wrapper and the quick-add trigger when it is a plain PDP link.
    card.querySelectorAll('a[href]').forEach((link) => {
      if (link.closest('.swatches--product-card')) return;
      link.href = url;
    });

    const title = card.querySelector('.product-card__title a, .product-card__title');
    if (title && item.dataset.siblingTitle) title.textContent = item.dataset.siblingTitle;

    const price = card.querySelector('.f-price');
    if (price && item.dataset.siblingPrice) {
      const compare = item.dataset.siblingCompare;
      price.classList.toggle('f-price--on-sale', Boolean(compare));
      price.classList.toggle('f-price--vip', Boolean(compare));
      price.querySelectorAll('.f-price-item--regular, .f-price-item--sale').forEach((node) => {
        node.textContent = item.dataset.siblingPrice;
      });
      price.querySelectorAll('.f-price-item--compare').forEach((node) => {
        node.textContent = compare || '';
      });
    }

    card.querySelectorAll('.swatches--product-card a[aria-current]').forEach((node) => {
      node.removeAttribute('aria-current');
    });
    chip.setAttribute('aria-current', 'true');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast-banner"] && !Shopify.designMode) return;
  try {
    class ToastBanner extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('.toast-banner__template');
      this.defaultDuration = parseInt(this.dataset.duration, 10);
      if (isNaN(this.defaultDuration)) {
        this.defaultDuration = 4000;
      }
      this.defaultActionLabel = this.dataset.defaultActionLabel || '';

      this._onShow = (event) => {
        this.show(event.detail || {});
      };
      document.addEventListener('toast:show', this._onShow);

      if (!window.showToast) {
        window.showToast = function (options) {
          const region = document.querySelector('toast-banner');
          if (region) {
            return region.show(options || {});
          }
          return null;
        };
      }

      const initial = this.querySelector('.toast-banner__initial');
      if (initial) {
        try {
          this.show(JSON.parse(initial.textContent));
        } catch (error) {
          /* malformed initial payload: skip */
        }
        initial.remove();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('toast:show', this._onShow);
    }

    show(options) {
      if (!this.template) {
        return null;
      }
      const opts = options || {};
      const status = opts.status || 'default';
      const urgent = status === 'warning' || status === 'error';

      const node = this.template.content.firstElementChild.cloneNode(true);
      node.classList.add('toast--' + status);
      node.setAttribute('role', urgent ? 'alert' : 'status');
      node.setAttribute('aria-live', urgent ? 'assertive' : 'polite');

      const headingEl = node.querySelector('.toast__heading');
      const subEl = node.querySelector('.toast__subcopy');
      if (opts.heading) {
        headingEl.textContent = opts.heading;
      } else {
        headingEl.remove();
      }
      if (opts.subcopy) {
        subEl.textContent = opts.subcopy;
      } else {
        subEl.remove();
      }

      const actionWrap = node.querySelector('.toast__action');
      const label = opts.action_label || opts.actionLabel;
      if (label) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'toast__action-button';
        button.textContent = label;
        button.addEventListener('click', () => {
          node.dispatchEvent(new CustomEvent('toast:action', { bubbles: true, detail: opts }));
          this.dismiss(node, 'action');
        });
        actionWrap.appendChild(button);
      } else {
        actionWrap.remove();
      }

      this.appendChild(node);

      let duration = parseInt(opts.duration, 10);
      if (isNaN(duration)) {
        duration = this.defaultDuration;
      }
      node._duration = duration;

      requestAnimationFrame(() => {
        node.removeAttribute('hidden');
        requestAnimationFrame(() => {
          node.classList.add('is-visible');
        });
      });

      this._arm(node);
      node.addEventListener('mouseenter', () => this._clear(node));
      node.addEventListener('mouseleave', () => this._arm(node));
      node.addEventListener('focusin', () => this._clear(node));
      node.addEventListener('focusout', () => this._arm(node));

      return node;
    }

    _arm(node) {
      this._clear(node);
      if (node._duration > 0 && !node._dismissed) {
        node._timer = window.setTimeout(() => this.dismiss(node, 'timeout'), node._duration);
      }
    }

    _clear(node) {
      if (node._timer) {
        window.clearTimeout(node._timer);
        node._timer = null;
      }
    }

    dismiss(node, reason) {
      if (node._dismissed) {
        return;
      }
      node._dismissed = true;
      this._clear(node);
      node.classList.remove('is-visible');
      node.dispatchEvent(new CustomEvent('toast:dismiss', { bubbles: true, detail: { reason: reason } }));

      const remove = () => {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      };

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        remove();
        return;
      }

      let done = false;
      const onEnd = () => {
        if (done) {
          return;
        }
        done = true;
        node.removeEventListener('transitionend', onEnd);
        remove();
      };
      node.addEventListener('transitionend', onEnd);
      window.setTimeout(onEnd, 500);
    }
  }

  if (!customElements.get('toast-banner')) {
    customElements.define('toast-banner', ToastBanner);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tooltip"] && !Shopify.designMode) return;
  try {
    (function () {
    function forEachOpen(callback) {
      var open = document.querySelectorAll('.tooltip-wrap:hover, .tooltip-wrap:focus-within');
      Array.prototype.forEach.call(open, callback);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      forEachOpen(function (wrap) {
        wrap.classList.add('is-dismissed');
        if (typeof wrap.blur === 'function') wrap.blur();
      });
    });

    document.addEventListener('mouseleave', function (event) {
      var target = event.target;
      if (target && target.classList && target.classList.contains('tooltip-wrap')) {
        target.classList.remove('is-dismissed');
      }
    }, true);

    document.addEventListener('focusout', function (event) {
      var wrap = event.target.closest ? event.target.closest('.tooltip-wrap') : null;
      if (wrap) wrap.classList.remove('is-dismissed');
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
